import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { ManagementFeeSettings, ManagementFeeSettingsCompanyPortalTypedSettingsWithOverridesDocument } from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const MANAGEMENT_FEES_SETTINGS_URL = `${SETTINGS_BASE_URL}/managementfee`;

export class managementFeesSettingsRepository extends BaseRestRepository {
  public async getAllManagementFeesSettings(): Promise<ManagementFeeSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = `${MANAGEMENT_FEES_SETTINGS_URL}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateManagementFeesSettings(data: ManagementFeeSettings): Promise<ManagementFeeSettings> {
    const url = `${MANAGEMENT_FEES_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: data }),
    });
    return this.getJsonResponse(response);
  }

  public async updateManagementFeesSettingsByLevel(
    level: string,
    levelId: string,
    data: ManagementFeeSettings
  ): Promise<ManagementFeeSettings> {
    const url = MANAGEMENT_FEES_SETTINGS_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: data,
        targets: [{ level, levelId }],
      }),
    });
    return this.getJsonResponse(response);
  }

  public async getManagementFeesSettingsByLevel(level: string, levelId: string): Promise<ManagementFeeSettings> {
    const url = `${MANAGEMENT_FEES_SETTINGS_URL}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async deleteManagementFeesSettingsByLevel(level: string, levelId: string): Promise<void> {
    const url = `${MANAGEMENT_FEES_SETTINGS_URL}/${level}/${levelId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
